import { countryRefDataSource } from '../state/country-datasource'

/**
 * Shared country reference data for select/combobox pickers. All callers share
 * one module-level cache (see `state/country-datasource.ts`).
 */
export function useSelectCountryDataSource() {
  return {
    countries: countryRefDataSource.items,
    loadingCountries: countryRefDataSource.loading,
    fetchCountries: countryRefDataSource.fetch,
    addCountry: countryRefDataSource.upsert,
    getCountry: countryRefDataSource.get
  }
}
